module.exports = __webpack_public_path__ + "static/media/utensil-fork.a2f4987f.svg";